export default __webpack_public_path__ + "static/media/sports16.4f6c81df.jpg";